import Vue from 'vue';
import pushid from 'pushid';
import { EventBus } from '@/helpers/event-bus';
import { findRecursiveInObject, api, toArray, success, error, shuffle } from '@/helpers/utils';

export const File = {
    state: {
        active: {},
        uploading: false
    },
    mutations: {
        setActiveFile(state, payload) {
            state.active = payload;
        },
        addActiveFile(state, payload) {
            Vue.set(state.active, payload.id, payload);
        },
        deleteActiveFile(state, payload) {
            Vue.delete(state.active, payload);
        },
        setUploadingState(state, payload) {
            state.uploading = payload;
        }
    },
    getters: {
        getFiles(state, getters, rootState) {
            return rootState.tecpage.files;
        },
        getReferencedFiles(state, getters, rootState) {
            let referencedFiles = [],
                allFiles = rootState.tecpage.files;
            if (
                typeof allFiles === 'object' &&
                allFiles !== null &&
                Object.keys(allFiles).length > 0
            ) {
                Object.values(allFiles).forEach((allFiles__value) => {
                    let references = findRecursiveInObject(
                        rootState.deha.user,
                        'id',
                        allFiles__value.id
                    ).concat(
                        findRecursiveInObject(rootState.tecpage.user, 'id', allFiles__value.id)
                    );
                    if (references.length > 0) {
                        references.forEach((references__value) => {
                            if (1 === 0) {
                                return;
                            }
                            let item = {};
                            item['file'] = allFiles__value;
                            item['page'] = null;
                            if (references__value.indexOf('modules.') === 0) {
                                let module = getters.getModuleById(references__value.split('.')[1]);
                                if ('page_id' in module) {
                                    item['page'] = getters.getPageFromId(module.page_id);
                                }
                            }
                            referencedFiles.push(item);
                        });
                    }
                });
            }
            return referencedFiles;
        },
        getFilemanagerData(state, getters, rootState) {
            if (rootState.route.query.filemanager) {
                return {
                    source: rootState.route.query.filemanager_source,
                    accept: rootState.route.query.filemanager_accept,
                    multiple: rootState.route.query.filemanager_multiple
                };
            }
            return null;
        },
        getFilemanagerSource(state, getters, rootState) {
            if (rootState.route.query.filemanager_source) {
                return rootState.route.query.filemanager_source;
            }
            return null;
        },
        isFilemanagerActive(state, getters, rootState) {
            if (rootState.route.query.filemanager) {
                return true;
            }
            return false;
        },
        getActiveFiles(state) {
            return state.active;
        },
        filesSelected(state) {
            return Object.keys(state.active).length > 0;
        },
        isActiveFile(state) {
            return (id) => {
                return Object.values(state.active).some((i) => i.id === id);
            };
        },
        getAcceptedFilesInFilemanager(state, getters) {
            if (getters.getFilemanagerData) {
                return getters.getFilemanagerData.accept;
            } else {
                return null;
            }
        },
        getFilemanagerFilesView(state, getters) {
            if (getters.getFilemanagerData) {
                let accept = getters.getFilemanagerData.accept;
                if (accept !== undefined && accept !== null && accept !== '') {
                    for (let accept__value of accept.split(',')) {
                        if (
                            ['.doc', '.docx', '.xls', '.xlsx', '.pdf', '.zip', '.exe'].indexOf(
                                accept__value
                            ) > -1
                        ) {
                            return 'documents';
                        }
                    }
                }
            }
            return 'images';
        },
        getFilemanagerFilesViewFromAccept() {
            return (accept) => {
                if (accept !== undefined && accept !== null && accept !== '') {
                    for (let accept__value of accept.split(',')) {
                        if (
                            ['.doc', '.docx', '.xls', '.xlsx', '.pdf', '.zip', '.exe'].indexOf(
                                accept__value
                            ) > -1
                        ) {
                            return 'documents';
                        }
                    }
                }
                return 'images';
            };
        },
        getRandomImageInNamespace(state, getters) {
            return (namespace) => {
                let files = getters.getFiles;
                files = toArray(files);
                files = files.filter((i) => {
                    return i.namespace === namespace;
                });
                if (files.length === 0) {
                    throw 'error: file in namespace ' + namespace + ' not found!';
                }
                files = shuffle(files);
                return files[0].id;
            };
        },
        getAllImagesInNamespace(state, getters) {
            return (namespace) => {
                let files = getters.getFiles;
                files = toArray(files);
                files = files.filter((i) => {
                    return i.namespace === namespace;
                });
                if (files.length === 0) {
                    throw 'error: file in namespace ' + namespace + ' not found!';
                }
                return files;
            };
        },
        getRandomButDeterminedImageInNamespace(state, getters) {
            return (namespace) => {
                let files = getters.getFiles;
                files = toArray(files);
                files = files.filter((i) => {
                    return i.namespace === namespace;
                });
                if (files.length === 0) {
                    throw 'error: file in namespace ' + namespace + ' not found!';
                }
                return files[parseInt(getters.getUserId) % files.length].id;
            };
        },
        getRandomButDeterminedImageInNamespaceBasedOnUser(state, getters) {
            return (namespace, id) => {
                let files = getters.getFiles;
                files = toArray(files);
                files = files.filter((i) => {
                    return i.namespace === namespace;
                });
                if (files.length === 0) {
                    throw 'error: file in namespace ' + namespace + ' not found!';
                }
                let idAsInt =
                    id
                        .split('')
                        .map((i) => i.charCodeAt(0))
                        .reduce((a, b) => a + b, 0) % 10;
                return files[parseInt(idAsInt) % files.length].id;
            };
        },
        isMultiple(state, getters) {
            if (getters.getFilemanagerData) {
                return getters.getFilemanagerData.multiple == '1';
            } else {
                return false;
            }
        },
        getRelevantFiles(state, getters) {
            return (folder) => {
                return toArray(getters.getFiles)
                    .filter((i) => {
                        return i.folder.indexOf(folder) === 0;
                    })
                    .filter((i) => {
                        let extension =
                            '.' + i.filename.split('.')[i.filename.split('.').length - 1];
                        return getters.getFilemanagerData.accept.split(',').indexOf(extension) > -1;
                    })
                    .filter((i) => {
                        /* hardcoded exception (in the future we make this work with namespaces) */
                        return i.namespace === null || i.namespace.indexOf('brands') === -1;
                    })
                    .sort((a, b) => {
                        if (a.id < b.id) {
                            return 1;
                        }
                        if (a.id > b.id) {
                            return -1;
                        }
                        return 0;
                    });
            };
        },
        getFileById(state, getters, rootState) {
            return (id) => {
                if (id === undefined || id === null || id === '') {
                    return undefined;
                }
                return Object.values(rootState.tecpage.files).find((i) => i.id === id);
            };
        },
        getFiletypeById(state, getters, rootState) {
            return (id) => {
                if (id === undefined || id === null || id === '') {
                    return undefined;
                }
                let file = Object.values(rootState.tecpage.files).find((i) => i.id === id);
                if (file === undefined || file === null || file === '') {
                    return undefined;
                }
                return file.filetype;
            };
        },
        fileIsImage(state, getters) {
            return (id) => {
                let file = getters.getFileById(id);
                if (file === undefined || file === null) {
                    return false;
                }
                let extension = file.filename.split('.')[file.filename.split('.').length - 1];
                return ['jpg', 'png', 'gif'].indexOf(extension) > -1;
            };
        },
        acceptIsImage() {
            return (accept) => {
                accept = accept.split(',');
                return (
                    accept.includes('.jpg') || accept.includes('.png') || accept.includes('.gif')
                );
            };
        },
        generateMediaUrl(state, getters) {
            return ({ id, path, w, h, i, v }) => {
                if (id !== undefined) {
                    let file = getters.getFileById(id);
                    if (file === undefined) {
                        return null;
                    }
                    path = file.folder + '/' + file.filename;
                }
                if (path === undefined || path === null || path === '') {
                    return null;
                }
                let url =
                    process.env.VUE_APP_URL.replace(':8080', '') +
                    '/files/user/' +
                    getters.getUserId +
                    '/' +
                    path;
                let params_url = [];
                if (w !== undefined && w !== null && w !== '') {
                    params_url.push('w=' + w);
                }
                if (h !== undefined && h !== null && h !== '') {
                    params_url.push('h=' + h);
                }
                if (i !== undefined && i !== null && i !== '') {
                    params_url.push('i=' + i);
                }
                if (v !== undefined && v !== null && v !== '') {
                    params_url.push('v=' + v);
                }
                /* we also append the id: this leads to very pragmatic caching. */
                /* if the id changes (and the filename is the same as another file before,
                /* the file gets automatically reloaded!) */
                if (id !== undefined) {
                    params_url.push('id=' + id);
                }
                if (params_url.length > 0) {
                    url += '?' + params_url.join('&');
                }
                return url;
            };
        },
        isFileeditorActive(state, getters, rootState) {
            if (rootState.route.query.fileeditor) {
                return true;
            }
            return false;
        },
        getActiveFileeditorFileId(state, getters, rootState) {
            if (rootState.route.query.fileeditor_file_id) {
                return rootState.route.query.fileeditor_file_id;
            }
            return null;
        },
        getActiveFileeditorFile(state, getters, rootState) {
            if (rootState.route.query.fileeditor_file_id !== undefined) {
                let prop = getters.getProp(
                    'tecpage.files.' + rootState.route.query.fileeditor_file_id
                );
                if (prop === undefined) {
                    return null;
                }
                return prop;
            }
            return null;
        },
        isFileDeletable(state, getters) {
            return (id) => {
                let file = getters.getFileById(id);
                if (file === undefined) {
                    return false;
                }
                return file.folder === 'uploads';
            };
        },
        getFileExtension(state, getters) {
            return (id) => {
                let file = getters.getFileById(id);
                if (file === undefined) {
                    return undefined;
                }
                return file.filename.split('.')[file.filename.split('.').length - 1];
            };
        },
        getFileFilename(state, getters) {
            return (id) => {
                let file = getters.getFileById(id);
                if (file === undefined) {
                    return undefined;
                }
                return file.filename;
            };
        },
        isCurrentlyUploading(state) {
            return state.uploading;
        }
    },
    actions: {
        async openFilemanager(context, payload) {
            await context.dispatch('routeRemoveQuery', ['textpicker', 'textpicker_namespace']);
            await context.dispatch('routeAddQuery', {
                filemanager: 1,
                filemanager_source: payload.source,
                filemanager_accept: payload.accept,
                filemanager_multiple: payload.multiple === true ? 1 : 0
            });
            let files = await context.dispatch('waitForFiles');
            return files;
        },
        async waitForFiles() {
            return await new Promise((resolve) => {
                EventBus.$on('filemanagerSaved', (data) => {
                    EventBus.$off('filemanagerSaved'); // only do this once
                    resolve(data);
                });
            });
        },
        async closeFilemanager(context) {
            await context.dispatch('emitAndCloseFilemanager', null);
        },
        async saveAndCloseFilemanager(context) {
            let files = await context.dispatch('saveFilemanager', context.getters.getActiveFiles);
            await context.dispatch('emitAndCloseFilemanager', files);
        },
        async emitAndCloseFilemanager(context, payload) {
            EventBus.$emit('filemanagerSaved', payload);
            context.commit('setActiveFile', {});
            await context.dispatch('routeRemoveQuery', [
                'filemanager',
                'filemanager_source',
                'filemanager_accept',
                'filemanager_multiple',
                'fileeditor',
                'fileeditor_file_id'
            ]);
        },
        async saveFilemanager(context, payload) {
            let files;
            if (context.getters.isMultiple) {
                files = {};
                let pos = 1;
                Object.values(payload).forEach((payload__value) => {
                    files[payload__value.id] = { id: payload__value.id, pos: pos };
                    pos++;
                });
            } else {
                files = { id: Object.values(payload).find(() => true).id, pos: 1 };
            }
            return files;
        },
        async toggleActiveFile(context, id) {
            if (Object.values(context.state.active).some((i) => i.id === id)) {
                context.commit('deleteActiveFile', id);
            } else {
                let file = Object.values(context.rootState.tecpage.files).find((i) => i.id === id);
                if (context.rootState.route.query.filemanager_multiple == '1') {
                    context.commit('addActiveFile', file);
                } else {
                    context.commit('setActiveFile', { [file.id]: file });
                }
            }
        },
        async updateFile(context, id) {
            await api('tecpage-api', '/files/' + id, 'PUT', {
                copyright: context.getters.getProp('tecpage.files.' + id + '.copyright'),
                alt: context.getters.getProp('tecpage.files.' + id + '.alt')
            });
        },
        async removeFile(context, { id, confirm, save, route }) {
            if (confirm === true) {
                EventBus.$emit('controlhead-remove-open', context.getters.getCurrentRouteFullPath);
                EventBus.$once('controlhead-remove-accepted', async () => {
                    await context.dispatch('removeFile', {
                        confirm: false,
                        id: id,
                        route: route,
                        save: save
                    });
                });
                EventBus.$once('controlhead-remove-denied', () => {});
            } else {
                if (route === true) {
                    await context.dispatch(
                        'forgetDifferInRoute',
                        context.getters.getCurrentRouteFullPath
                    );
                    await context.dispatch('routeRemoveQuery', [
                        'fileeditor',
                        'fileeditor_file_id'
                    ]);
                }

                /* remove main entry and all references */
                let references = findRecursiveInObject(context.rootState, 'id', id);
                if (references.length > 0) {
                    for (let references__value of references) {
                        await context.dispatch('removeProp', {
                            source: references__value
                        });
                    }
                }
                if (save === true) {
                    await api('tecpage-api', '/files/' + id, 'DELETE');
                }
                success('Erfolgreich gelöscht');
            }
        },
        async uploadInFilemanager(context, payload) {
            context.commit('setUploadingState', true);
            let files = payload.event.target.files;
            if (files.length === 0) {
                return Promise.reject();
            }
            let hasError = false;
            let lastId = null;
            for (let i = 0; i < files.length; i++) {
                let file = files[i],
                    reader = new FileReader();
                await new Promise((resolve, reject) => {
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        resolve();
                    };
                    reader.onerror = () => {
                        reject();
                    };
                });
                try {
                    let response = await api('tecpage-api', '/files', 'POST', {
                        id: pushid(),
                        folder: payload.folder,
                        filename: file.name,
                        filetype: file.type,
                        copyright: context.getters.getProp('deha.user.firma1'),
                        base64: reader.result.split(',')[1]
                    });
                    await context.dispatch('setProp', {
                        source: 'tecpage.files.' + response.data.id,
                        value: response.data
                    });
                    lastId = response.data.id;
                    success('Erfolgreicher Upload!');
                } catch (e) {
                    hasError = true;
                    error(e !== undefined && e.public_message !== undefined ? e.public_message : e);
                }
            }
            context.commit('setUploadingState', false);
            /* immediately open fileeditor and set active */
            if (lastId) {
                if (context.getters.fileIsImage(lastId)) {
                    await context.dispatch('routeAddQuery', {
                        fileeditor: 1,
                        fileeditor_file_id: lastId
                    });
                }
                await context.dispatch('toggleActiveFile', lastId);
            }
            payload.event.target.value = '';
            if (hasError === true) {
                return Promise.reject();
            } else {
                return Promise.resolve();
            }
        }
    }
};
